import { render, staticRenderFns } from "./AgentPermissionsGroup.vue?vue&type=template&id=2094beb2"
import script from "./AgentPermissionsGroup.vue?vue&type=script&lang=js"
export * from "./AgentPermissionsGroup.vue?vue&type=script&lang=js"
import style0 from "./AgentPermissionsGroup.vue?vue&type=style&index=0&id=2094beb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports